import React, { FC } from 'react';
import styles from './results_card.module.scss';
import { Paper } from '../../../../components/paper/Paper';

export const SearchCard: FC = ({ children }) => (
  <Paper level={0} className={styles.searchCard}>
    {children}
  </Paper>
);

export const FollowContainer: FC = (props) => (
  <div className={styles.followContainer} {...props} />
);

export const SearchCardTitle: FC = (props) => (
  <div className={styles.title} {...props} />
);

export const SearchCardFooter: FC = (props) => (
  <div className={styles.footer} {...props} />
);
export const SearchCardList: FC = (props) => (
  <div className={styles.list} {...props} />
);
